import React from "react";
import { Normalize } from "styled-normalize";
import styled, { ThemeProvider, css } from "styled-components";
import GlobalStyle from "storybook-styles/global";
import theme from "storybook-styles/theme";
import Header from "storybook-components/Header";
import Footer from "storybook-components/Footer";
import { FinalCta } from "storybook-components/FinalCta";
import HiddenBanner from "storybook-components/HiddenBanner";
import Nav from "./BlogNav";
import RelatedContentSidebar from "./RelatedContentSidebar";

const BackgroundColorWrapper = styled.div`
  background-color: ${props => props.color};
  width: 100%;
`;

const FlexOneCss = css`
  flex: 1;
`;

const NavContainerWidth = css`
  width: 360px;
`;

const MainContainerWidth = css`
  width: calc(100% - 360px);
`;

const SiteWrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
`;

const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${props =>
    props.centerContent ? `space-around` : `flex-start`};
`;

const SideNavContainer = styled.div`
  display: none;
  ${theme.media.desktopUp`
    display: block;
    position: sticky;
    ${props => !props.centerContent && NavContainerWidth}
    ${props => props.centerContent && FlexOneCss}
  `};
`;

const MainContainer = styled.div`
  width: 100%;
  ${props => props.centerContent && FlexOneCss}
  margin-bottom: 60px;
  ${theme.media.desktopUp`
    min-width: 750px;
    ${props => !props.centerContent && MainContainerWidth}
  `};
  ${theme.media.wideScreenUp`
    ${props => props.centerContent && FlexOneCss}
  `};
`;

const FlexCenteringSpacer = styled.div`
  display: none;
  ${theme.media.wideScreenUp`
    display: block;
    flex: 1;
  `};
`;

const ChildrenWrapper = styled.div`
  width: 100%;
  overflow: visible;

  ${props => props.theme.media.tabletUp`
    overflow: hidden;
    margin-top: 60px; 
  `};
`;

const Layout = ({
  children,
  blogPostData,
  centerContent,
  hideFinalCta,
  backgroundColor,
  showRelatedContent
}) => (
  <ThemeProvider theme={theme}>
    <BackgroundColorWrapper color={backgroundColor || theme.colors.white}>
      <HiddenBanner hideMarketingBanner={false} />
      <SiteWrapper>
        <Normalize />
        <GlobalStyle />
        <Header />
        <FlexContainer>
          <SideNavContainer centerContent={centerContent}>
            {showRelatedContent ? (
              <RelatedContentSidebar />
            ) : (
              <Nav blogPostData={blogPostData} />
            )}
          </SideNavContainer>
          <MainContainer centerContent={centerContent}>
            <ChildrenWrapper>{children}</ChildrenWrapper>
          </MainContainer>
          {centerContent && <FlexCenteringSpacer />}
        </FlexContainer>
        {!hideFinalCta && <FinalCta />}
      </SiteWrapper>
      <Footer />
    </BackgroundColorWrapper>
  </ThemeProvider>
);

export default Layout;
